/**
 * Artemis Application Server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * API Version: 10.6
 * Contact: krusche@tum.de
 *
 * NOTE: This file is auto-generated. Do not edit manually.
 */

import type { EntityIdRef } from './entity-id-ref';

export interface MultipleChoiceSubmittedAnswerFromLiveClient {
    quizQuestion?: EntityIdRef;
    selectedOptions?: Array<EntityIdRef>;
    type: MultipleChoiceSubmittedAnswerFromLiveClientTypeEnum;
}

export type MultipleChoiceSubmittedAnswerFromLiveClientTypeEnum = 'multiple-choice';

export const MultipleChoiceSubmittedAnswerFromLiveClientTypeEnum = {
    MultipleChoice: 'multiple-choice' as const,
} as const;

export const MultipleChoiceSubmittedAnswerFromLiveClientTypeEnumValues = ['multiple-choice'] as const;
